// extracted by mini-css-extract-plugin
export var divider = "_tq-0";